import { render } from "./BedrijfsRuimtes.vue?vue&type=template&id=75ed157d"
import script from "./BedrijfsRuimtes.vue?vue&type=script&lang=js"
export * from "./BedrijfsRuimtes.vue?vue&type=script&lang=js"

import "./BedrijfsRuimtes.vue?vue&type=style&index=0&id=75ed157d&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__